import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';


const TableSummary = ({ store }) => (
    <div>
        {store.totalCount && store.totalCount > 0 ? (
            <small>
                Elements {' '}
                {(store.page * store.limit) + 1} {' '}
                through {' '}
                {Math.min(store.totalCount, (store.page + 1) * store.limit)} {' '}
                out of {' '}
                {store.totalCount}
            </small>) : <small>No elements found.</small>}
    </div>);


TableSummary.propTypes = {
    store: PropTypes.object.isRequired,
};

export default (observer(TableSummary));
